/*eslint-disable*/
import React, { useState, useEffect } from "react";

import APIClient from "../client";
import config from "../config.js";
import AuthNavbar from "../components/Navbars/AuthNavbar.js";
import DisplayNameDropdown from "../components/dropdowns/DisplayNameDropdown.js";
import CardInvestorDashboard from "../components/Cards/CardInvestorDashboard.js";
import CardInvestorAggregate from "../components/Cards/CardInvestorAggregate.js";
import CardError from "../components/Cards/CardError.js";

import '../assets/styles/App.css';
import "@fontsource/montserrat";


const client = new APIClient(config);


export default function InvestorDashboard() {
  const [dropDowndata, setDropDown] = useState(null);
  const [aggregateData, setAggregateDate] = useState(null);
  const [funderData, setFunderData] = useState(null);
  const [chartData, setChartData] = useState(null);

  const [lastUpdate, setLastUpdate] = useState(null);

  const [loading, setLoading] = useState(true);

  const [aggStatus, setAggStatus] = useState();
  const [status, setStatus] = useState();
  const [error, setError] = useState(null);

  const [selected, setSelected] = useState(null);

  useEffect(() => {
    try {
      fetchDropdownData();
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }, []);


  const fetchDropdownData = () => {

    Promise.all([
            client.getFunderNames(),
            client.getFunderAggregate()
        ])
            .then(([resDropDown, resAggregate]) =>
                Promise.all([resDropDown, resAggregate])
            )
            .then(([dataDropDown, dataAggregate]) => {
                if ([dataDropDown, dataAggregate]) {
                  setDropDown(dataDropDown['data']['data'].sort((a, b) => a.display_name.localeCompare(b.display_name)));
                  setAggregateDate(dataAggregate['data']['data']);
                  setAggStatus(200);
                  setLoading(false);
                  setSelected(0);
                  setError(null);
                } else {
                    setAggStatus(500);
                }
            })
            .catch(function (error) {
                setAggStatus(500);
                setError("Looks like we cant show this at the moment.");

            });
  };


  const fetchDataForFunder = async (event) => {
    const value = event;

    if (parseInt(Number(value)) > -1) {
    try {

      client.getFunderSummaryData(value).then((data) => {

        setFunderData(data['data']['data']);
        setLastUpdate(data['data']['data']['lastUpdate']);

        const sampleData = {
          "collections": {
            "xLabels": ["Total Collection Rate", "Initial Rate", "30 DPD Rate", "60 DPD Rate", "90 DPD Rate", "120 DPD Rate", "150 DPD Rate"],
            "yLabels": data['data']['data']["reporting_year_month"],
            "data": data['data']['data']["collection_rates"],
          },
          "yield": {
            "xLabels": ["Total Yield", "Initial Yield", "30 DPD Yield", "60 DPD Yield", "90 DPD Yield", "120 DPD Yield", "150 DPD Yield"],
            "yLabels": data['data']['data']["reporting_year_month"],
            "data": data['data']['data']["yield_rates"],
          },
          "disbursement": {
            "labels": data['data']['data']["reporting_year_month"],
            "dataset": data['data']['data']["disbursed_local"],
            "netdata": data['data']['data']["net_cash_flow"],
            "collections": data['data']['data']["total_collected"],
            "risk_adjusted_return": data['data']['data']["risk_adjusted_return"],
          },
          "disbursement_cumulative": {
            "labels": data['data']['data']["reporting_year_month_current"],
            "disbursed_to_date_local": data['data']['data']["disbursed_to_date_local"],
            "disbursed_to_date_usd": data['data']['data']["disbursed_to_date_usd"],
          },
          "partner": data['data']['data']["partner"],
          "funder": data['data']['data']["funder"],
          "lastUpdate": data['data']['data']["lastUpdate"],
          "currency": data['data']['data']["currency"],
          "currency_code": data['data']['data']["currency_code"],
          "country": data['data']['data']["country"],
          "disbursement_target": data['data']['data']["disbursement_target"],
          "yield_target": data['data']['data']["yield_target"],
          "cor_target": data['data']['data']["cor_target"],
          "ytd_yield": data['data']['data']["ytd_yield"],
          "ytd_collection_rate": data['data']['data']["ytd_collection_rate"],
          "qualified_applications": data['data']['data']["qualified_applications"],
          "unqualified_applications": data['data']['data']["unqualified_applications"],
          "has_opportunity": data['data']['data']['has_opportunity']
        };

        setChartData(sampleData);

        setError(null);
        setLoading(false);
        setStatus(200);
        setAggStatus(401);

      });

    } catch (error) {
      setStatus(500);
      setError(err.message);
    }
    } else {
      fetchDropdownData();
      setStatus(401);
    }
  };

  document.title = "Investment";

  return (
    <>
      <section>
        <AuthNavbar />
      </section>

      <section className="relative grad-1 pb-20 ">
        <div className="container relative mx-auto pt-12 px-4 w-10/12">
          <h2 className="text-36 text-yellow mb-3">Investment</h2>
          <p className="text-20-30 text-white">
            An overview of portfolio performance.

          </p>
          <br/>

          {loading && (
              <div className="text-xl text-yellow font-medium">Loading...</div>
          )}

          {dropDowndata ? (


              <div className="relative w-full px-4 mb-2">
                <div className="relative bg-white-2 w-full rounded-lg p-2">
                  <DisplayNameDropdown
                      options={dropDowndata}
                      selected="All Portfolios"
                      onSelectedChange={fetchDataForFunder}
                  />
                </div>
              </div>


          ): (
              <CardError message={error}/>
            )

          }

          {(status === 200) ?
                        (

              <>

                <CardInvestorDashboard chartData={chartData}/>

                <div className="container mx-auto mt-b px-8">
                  <p className="text-white text-16-150 text-right">Last updated {lastUpdate.substring(0, 10)}</p>

                </div>
              </>


          ): (
                 <></>
              )
          }

          {(aggStatus === 200) ?
                        (
                            <>
                            <CardInvestorAggregate chartData={aggregateData}/>
                            </>
                        ) : ( <></>)
          }

          {error ?
                        (

              <>
                <CardError message={error}/>
              </>


          ): (
                 <></>
              )
          }



        </div>

      </section>

    </>
  );

}